import React, { useContext } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import { RadioGroupStep } from "#/components/carrot-card-cost-share/steps/variants/RadioGroupStep"
import { CarrotCardCostSharePreAuthContext } from "../../state/CarrotCardCostSharePreAuthContext"
import { useConvertTranslatedLabel } from "#/services/common-forms/useConvertTranslatedLabel"
import { FormSelectOption } from "@carrotfertility/carotene-core-x"
import { Link } from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"

const iuiCyclesOptions = [
  { label: defineMessage({ defaultMessage: "1" }), value: "1" },
  { label: defineMessage({ defaultMessage: "2" }), value: "2" },
  { label: defineMessage({ defaultMessage: "3" }), value: "3" },
  { label: defineMessage({ defaultMessage: "4" }), value: "4" }
]

export function HowManyIUICyclesStep(): JSX.Element {
  const intl = useIntl()
  const { send } = useStateMachine()
  const {
    dispatchFormState,
    formState: { howManyIUICycles }
  } = useContext(CarrotCardCostSharePreAuthContext)

  const formattedOptions = useConvertTranslatedLabel(iuiCyclesOptions) as FormSelectOption[]

  function onSubmit(formValues: { [key: string]: string }): void {
    dispatchFormState({
      type: "UPDATE_FIELD",
      field: "howManyIUICycles",
      value: formValues.howManyIUICycles
    })
    send("")
  }

  return (
    <RadioGroupStep
      title={intl.formatMessage({
        defaultMessage: "Including this one, how many IUI cycles have you had with an OB/GYN?"
      })}
      description={
        <FormattedMessage
          defaultMessage="We cover a maximum of four IUI cycles with an OB/GYN. See your <link>benefit guide</link> for more information. If this is your fifth cycle or more, please do not submit this authorization."
          values={{
            link: (linkContent) => (
              <Link
                component={RouterLink}
                to={DbgPaths.FERTILITY_COVERAGE}
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkContent}
              </Link>
            )
          }}
        />
      }
      name="howManyIUICycles"
      options={formattedOptions}
      onSubmit={onSubmit}
      defaultValue={howManyIUICycles}
    />
  )
}
